<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
	@import url('assets/css/style.css');
	html,body{
		margin: 0;
		padding: 0;
		background: #F2F4F7;
	}
	a{
		text-decoration: none;
	}
</style>
